'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _ = require('../');

var _FinanceCompanyProfileModal = require('./FinanceCompanyProfileModal.css');

var _FinanceCompanyProfileModal2 = _interopRequireDefault(_FinanceCompanyProfileModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FinanceCompanyProfileModal = (_dec = (0, _reactCssModules2.default)(_FinanceCompanyProfileModal2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FinanceCompanyProfileModal, _Component);

  function FinanceCompanyProfileModal(props) {
    (0, _classCallCheck3.default)(this, FinanceCompanyProfileModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FinanceCompanyProfileModal.__proto__ || (0, _getPrototypeOf2.default)(FinanceCompanyProfileModal)).call(this, props));

    _this.openModal = function () {
      _this.setState({ modalOpen: true });
    };

    _this.closeModal = function () {
      _this.setState({ modalOpen: false });
    };

    _this.state = {
      holding: props.holding,
      fundholding: props.fundholding,
      modalOpen: false
    };
    return _this;
  }

  (0, _createClass3.default)(FinanceCompanyProfileModal, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          holding = _state.holding,
          fundholding = _state.fundholding;

      if (!holding || !fundholding) {
        return null;
      }
      var weight = fundholding.long_weight;

      // bank details logic
      var isBank = holding.is_fossil_bank;
      var lendingAmount = null;
      var bankScore = null;
      var bankScoreContribution = null;
      if (isBank) {
        lendingAmount = _format2.default.money(holding.fossil_bank_lending_total, true, 'USD', true);
        bankScore = _format2.default.number(holding.fossil_bank_score, false, false, 1);
        bankScoreContribution = _format2.default.number(weight * holding.fossil_bank_score * 100, false, false, 1);
        bankScoreContribution = bankScoreContribution === '0.0' ? '<0.1' : bankScoreContribution;
      }

      // insurer details logic
      var isInsure = holding.is_fossil_insure;
      var insureScore = null;
      var insureScoreContribution = null;
      if (isInsure) {
        insureScore = _format2.default.number(holding.fossil_insure_score, false, false, 1);
        insureScoreContribution = _format2.default.number(weight * holding.fossil_insure_score * 100, false, false, 1);
        insureScoreContribution = insureScoreContribution === '0.0' ? '<0.1' : insureScoreContribution;
      }

      // policies
      var coal_policies = _config2.default.coalPolicyTool[holding.company_id];
      var oil_gas_policies = _config2.default.oilGasPolicyTracker[holding.company_id];

      var indicator0 = require('../../../static/images/ic_pastille_0.png');
      var indicator1 = require('../../../static/images/ic_pastille_1.png');
      var indicator2 = require('../../../static/images/ic_pastille_2.png');
      var indicator3 = require('../../../static/images/ic_pastille_3.png');
      var indicator4 = require('../../../static/images/ic_pastille_4.png');

      var policy_mapper_fn = function policy_mapper_fn(x) {
        var result = null;
        switch (x) {
          case -2:
            result = 'NA';
            break;
          case -1:
            result = 'Not found';
            break;
          default:
            result = x;
            break;
        }
        return result;
      };

      var indicator_mapper_fn = function indicator_mapper_fn(x) {
        var result = null;
        switch (x) {
          case -2:
            result = 'NA';
            break;
          case -1:
            result = 'Not found';
            break;
          case 0:
            result = _react2.default.createElement('img', { src: indicator0, alt: 'No exclusion policy',
              title: 'No exclusion policy' });
            break;
          case 1:
            result = _react2.default.createElement('img', { src: indicator1, alt: 'Very weak exclusion policy',
              title: 'Very weak exclusion policy' });
            break;
          case 2:
            result = _react2.default.createElement('img', { src: indicator2, alt: 'Weak exclusion policy',
              title: 'Weak exclusion policy' });
            break;
          case 3:
            result = _react2.default.createElement('img', { src: indicator3, alt: 'Comprehensive exclusion policy',
              title: 'Comprehensive exclusion policy' });
            break;
          case 4:
            result = _react2.default.createElement('img', { src: indicator4, alt: 'Robust exclusion policy',
              title: 'Robust exclusion policy' });
            break;
          default:
            result = 'ERROR';
            break;
        }
        return result;
      };

      var coal_policies_mapped = null;
      var oil_gas_policies_mapped = null;
      var oil_gas_indicators_mapped = null;
      if (coal_policies) {
        coal_policies_mapped = coal_policies.map(function (x) {
          return policy_mapper_fn(x);
        });
      }
      if (oil_gas_policies) {
        oil_gas_policies_mapped = oil_gas_policies.slice(0, 3).map(function (x) {
          return policy_mapper_fn(x);
        });
        oil_gas_indicators_mapped = oil_gas_policies.slice(3, oil_gas_policies.length).map(function (x) {
          return indicator_mapper_fn(x);
        });
      }

      //
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'span',
          { onClick: this.openModal, styleName: 'modal-opener' },
          this.props.children
        ),
        _react2.default.createElement(
          _reactModal2.default,
          {
            isOpen: this.state.modalOpen,
            onRequestClose: this.closeModal,
            contentLabel: 'This fund is managed by',
            style: {
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                zIndex: '999999'
              },
              content: {
                position: 'absolute',
                left: 0,
                right: 0,
                marginLeft: 'auto',
                marginRight: 'auto',
                borderRadius: 0,
                width: '900px',
                maxWidth: '90%',
                top: '50%',
                border: '0px',
                background: '#fff',
                overflow: 'visible',
                bottom: 'auto',
                WebkitOverflowScrolling: 'touch',
                outline: 'none',
                transform: 'translateY(-50%)',
                padding: 0,
                maxHeight: '80%',
                overflowY: 'auto'
              }
            } },
          _react2.default.createElement(
            'div',
            { styleName: 'family-modal-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'family-modal' },
              _react2.default.createElement(
                'h1',
                { styleName: 'family-modal-header' },
                holding.security_name
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'family-modal-data-row' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'family-modal-data-row-header' },
                  _react2.default.createElement(
                    'h2',
                    null,
                    isBank ? 'Finance' : 'Insurance',
                    ' score'
                  ),
                  isBank ? _react2.default.createElement(
                    'p',
                    { styleName: 'family-modal-data-row-header-source' },
                    'Source: ',
                    _react2.default.createElement(
                      _.Link,
                      {
                        to: 'https://www.bankingonclimatechaos.org/',
                        title: 'Banking on Climate Chaos',
                        xstrong: true
                      },
                      'Banking on Climate Chaos'
                    )
                  ) : _react2.default.createElement(
                    'p',
                    { styleName: 'family-modal-data-row-header-source' },
                    'Source: ',
                    _react2.default.createElement(
                      _.Link,
                      {
                        to: 'https://docs.google.com/spreadsheets/d/157kNo3-xg7qeVHi8SF21VqjXKrSjHixL9UOKFTp8PKQ/edit#gid=769793980',
                        title: 'Insure Our Future Scorecard',
                        xstrong: true
                      },
                      'Insure Our Future'
                    )
                  )
                ),
                isBank ? _react2.default.createElement(
                  'div',
                  { styleName: 'modal-flex-row' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Total financing'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Lending & underwriting of debt/equity issuances to fossil fuels, 2016-2023'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value' },
                        _react2.default.createElement(
                          'strong',
                          null,
                          lendingAmount
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Company risk score'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Total financing normalized 0-10 (10 is worst)',
                          _react2.default.createElement('br', null),
                          _react2.default.createElement(
                            _.Link,
                            {
                              to: _config2.default.routes.banksInsurance + '#methodology-fossil-fuel-finance',
                              title: 'Methodology',
                              xstrong: true
                            },
                            'Methodology'
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value' },
                        _react2.default.createElement(_.FinanceCompanyScore, { score: bankScore, large: true })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Fund score contribution'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Company risk score x holding weight',
                          _react2.default.createElement('br', null),
                          _react2.default.createElement(
                            _.Link,
                            {
                              to: _config2.default.routes.banksInsurance + '#methodology-fossil-fuel-finance',
                              title: 'Methodology',
                              xstrong: true
                            },
                            'Methodology'
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value' },
                        _react2.default.createElement(
                          'strong',
                          null,
                          bankScore,
                          ' x ',
                          _format2.default.perc(weight),
                          ' = ',
                          bankScoreContribution
                        )
                      )
                    )
                  )
                ) : null,
                isInsure ? _react2.default.createElement(
                  'div',
                  { styleName: 'modal-flex-row' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Company risk score'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Fossil fuel insurance policy score, normalized 0-10 (10 is worst)'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value' },
                        _react2.default.createElement(_.FinanceCompanyScore, { score: insureScore, large: true })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Fund score contribution'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Company risk score x holding weight',
                          _react2.default.createElement('br', null),
                          _react2.default.createElement(
                            _.Link,
                            {
                              to: _config2.default.routes.banksInsurance + '#methodology-fossil-fuel-insurance',
                              title: 'Methodology',
                              xstrong: true
                            },
                            'Methodology'
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value' },
                        _react2.default.createElement(
                          'strong',
                          null,
                          insureScore,
                          ' * ',
                          _format2.default.perc(weight),
                          ' = ',
                          insureScoreContribution
                        )
                      )
                    )
                  )
                ) : null
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'family-modal-data-row' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'family-modal-data-row-header' },
                  _react2.default.createElement(
                    'h2',
                    null,
                    'Coal policy scores'
                  ),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'family-modal-data-row-header-source' },
                    'Source: ',
                    _react2.default.createElement(
                      _.Link,
                      {
                        to: 'https://coalpolicytool.org/',
                        title: 'Coal policy tool - Reclaim Finance',
                        xstrong: true
                      },
                      'coalpolicytool.org'
                    )
                  )
                ),
                coal_policies_mapped ? _react2.default.createElement(
                  'div',
                  { styleName: 'modal-flex-row' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Projects'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Exclusion of coal mines, coal plants, and coal infrastructure projects (10 is best)'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value-' + coal_policies[0] },
                        coal_policies_mapped[0]
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Developers'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Exclusion of coal companies developing new coal projects (10 is best)'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value-' + coal_policies[1] },
                        coal_policies_mapped[1]
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Relative threshold'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Exclusion of coal companies based on their coal share of revenue/power generation (10 is best)'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value-' + coal_policies[2] },
                        coal_policies_mapped[2]
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Absolute threshold'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Exclusion of coal companies based on their annual thermal coal production or their coal capacity (10 is best)'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value-' + coal_policies[3] },
                        coal_policies_mapped[3]
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Phase-out'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Quality of coal phase-out commitments (10 is best)'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value-' + coal_policies[4] },
                        coal_policies_mapped[4]
                      )
                    )
                  )
                ) : _react2.default.createElement(
                  'div',
                  { styleName: 'no-data-disclaimer' },
                  'No data for this company'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'family-modal-data-row' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'family-modal-data-row-header' },
                  _react2.default.createElement(
                    'h2',
                    null,
                    'Oil/gas policy scores'
                  ),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'family-modal-data-row-header-source' },
                    'Source: ',
                    _react2.default.createElement(
                      _.Link,
                      {
                        to: 'https://oilgaspolicytracker.org/',
                        title: 'Oil/gas policy tracker - Reclaim Finance',
                        xstrong: true
                      },
                      'oilgaspolicytracker.org'
                    )
                  )
                ),
                oil_gas_policies_mapped ? _react2.default.createElement(
                  'div',
                  { styleName: 'modal-flex-row' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Projects'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Immediate exclusion of oil and gas projects (10 is best)'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value-' + oil_gas_policies[0] },
                        oil_gas_policies_mapped[0]
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Expansion'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Exclusion of companies with oil and gas expansion plans (10 is best)'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value-' + oil_gas_policies[1] },
                        oil_gas_policies_mapped[1]
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Phase-out'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Quality of oil and gas phase-out commitments (10 is best)'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value-' + oil_gas_policies[2] },
                        oil_gas_policies_mapped[2]
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Arctic'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Exclusion policy for sector'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value' },
                        oil_gas_indicators_mapped[0]
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Fracking'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Exclusion policy for sector'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value' },
                        oil_gas_indicators_mapped[1]
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Tar sands'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Exclusion policy for sector'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value' },
                        oil_gas_indicators_mapped[2]
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'modal-flex-col' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-cell' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-label' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Ultra deep water'
                        ),
                        _react2.default.createElement(
                          'p',
                          { styleName: 'modal-cell-label-info' },
                          'Exclusion policy for sector'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'modal-cell-value' },
                        oil_gas_indicators_mapped[3]
                      )
                    )
                  )
                ) : _react2.default.createElement(
                  'div',
                  { styleName: 'no-data-disclaimer' },
                  'No data for this company'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'family-modal-close-wrap', onClick: this.closeModal },
            _react2.default.createElement('div', { styleName: 'family-modal-close', className: 'fa fa-times' })
          )
        )
      );
    }
  }]);
  return FinanceCompanyProfileModal;
}(_react.Component), _class2.propTypes = {
  holding: _react.PropTypes.object.isRequired,
  fundholding: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = FinanceCompanyProfileModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FinanceCompanyProfileModal/FinanceCompanyProfileModal.js
// module id = 1374
// module chunks = 0